export default "__VITE_ASSET__DyGQJxTJ__"